/**
 * @generated SignedSource<<fdf2a96cdfc3d226efca54a2da4722ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type subheaderMorningStudioSubheaderContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleShareWidgetArticle" | "articleSponsorContent">;
  readonly " $fragmentType": "subheaderMorningStudioSubheaderContent";
};
export type subheaderMorningStudioSubheaderContent$key = {
  readonly " $data"?: subheaderMorningStudioSubheaderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"subheaderMorningStudioSubheaderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "subheaderMorningStudioSubheaderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleShareWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSponsorContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "d72e888fc0c8421c60e3375275680d67";

export default node;
